import styles from './BackArrow.module.css';
import React from 'react';
export const BackArrow = ({ fill, onClick, dataTestId, }) => (<svg data-test-id={dataTestId} onClick={onClick} width="32" height="32" viewBox="0 0 32 32" fill={fill} xmlns="http://www.w3.org/2000/svg" className={styles.svg}>
    <path d="M20.5467 9.88L18.6667 8L10.6667 16L18.6667 24L20.5467 22.12L14.44 16L20.5467 9.88Z"/>
  </svg>);
